<template>
  <div ref="StackedLineMain" class="card" :class="cardTc" :style="style">
    <div class="card-header bg-gray-light border-0 pb-1" ref="headerChart">
      <h3 class="card-title font-weight-bolder">
        <i class="fas fa-th mr-1"></i>
        <v-tooltip top>
          <span class="justify-content-end align-content-end" style="font-size: 1.2rem">{{ title }}</span>
          <template v-slot:activator="{ on }">
            <span style="font-weight: 600;" v-if="title !== undefined && title !== null && title.length > 50">...</span>
            <span style="font-weight: 600;" v-on="on">{{ (title !== undefined && title !== null) ? title.slice(0, 50) : ""
            }}</span>
          </template>
        </v-tooltip>
      </h3>
      <div v-if="(!isFrameSetting)" class="card-tools mb-2 ml-auto">
        <ButtonView v-if="(isDashboard)" :frameId="frameId" />
        <ButtonViewSensor v-if="isDashboard" :frameId="frameId" />
        <ButtonExportPdf v-if="usePdf === 1 && isDashboard" :frameId="frameId" />
        <ButtonExportCsv v-if="useCsv === 1 && isDashboard" :frameId="frameId" :frameName="title"/>
        <ButtonExportExcel v-if="useExcel === 1 && isDashboard" :frameId="frameId" :frameName="title"/>
        <button v-if="isShowEdit" type="button" class="btn btn-sm" @click="clickClose">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <!-- <div ref="tagMain" class="card-body"> -->
    <v-layout column style="overflow: auto">
      <v-flex md6 grow style="overflow: auto; height: 100%;">
        <div :class="!isVertical ? classSticky : classStickyVertical">
        <v-data-table v-if="!isVertical" :headers="headerComputed" :items="listTableComputed" sort-by="calories" 
          class="" fixed-header hide-default-header mobile-breakpoint="0" :footer-props="{
            'items-per-page-text': $i18n.locale === 'en' ? 'Rows per page' : '1ページあたりの行数',
            'items-per-page-options': [100, 150, 200, 250, 300, 350, 400, 450, 500]
          }" ref="dataTable">
          <template #header="{ props: { headers } }">
            <thead class="v-data-table-header">
              <tr>
                  <th v-for="header in headers" :key="header.value" scope="col">
                  {{ $t(header.text) }}
                  </th>
              </tr>
            </thead>
          </template>
          <template v-for="(slot, i) in headerComputed" v-slot:[`item.${slot.value}`]="{ item }">
            <div :class="`text-color-${item[`${slot.value}_COLOR`]}`" :key="i" class="text-center data-text">
              {{ item[`${slot.value}`] }}
            </div>
          </template>
          <template v-slot:[`item.index`]="{ item }">
            <div class="text-center data-text" style="border: 1px solid #696666 !important;
                  text-align: center !important;    
                  font-size: 16px !important;
                  background-color: #DDDFEB !important;
                  color: #000 !important;">
              {{ item.index }}
            </div>
          </template>
          <template v-slot:[`item.measurementTime`]="{ item }">
            <div class="text-center data-text" >
              {{ commonFormatStrToDate(item.measurementTime, 7) }}
            </div>
          </template>
          <template v-slot:[`item.displayDataStation`]="{ item }">
            <div class="d-flex justify-center data-text">
              <v-checkbox :disabled="isDetailComputed" v-model="item.displayDataStation" color="primary"
                :value="item.displayDataStation"></v-checkbox>
            </div>
          </template>
          <template v-slot:[`item.data1`]="{ item }">
            <div :class="`text-color-${item.data1Color}`" class="data-text">
              {{ item.data1 }}
            </div>
          </template>
          <template v-slot:[`item.data2`]="{ item }">
            <div :class="`text-color-${item.data2Color}`" class="data-text">
              {{ item.data2 }}
            </div>
          </template>
          <template v-slot:[`item.data3`]="{ item }">
            <div :class="`text-color-${item.data3Color}`" class="data-text">
              {{ item.data3 }}
            </div>
          </template>
          <template v-slot:[`item.data4`]="{ item }">
            <div :class="`text-color-${item.data4Color}`" class="data-text">
              {{ item.data4 }}
            </div>
          </template>
          <template v-slot:[`item.data5`]="{ item }">
            <div :class="`text-color-${item.data5Color}`" class="data-text">
              {{ (deviceCodeProp != 100) ? item.data5 : humanReadableDirection(item.data5) }}
            </div>
          </template>
          <template v-slot:[`item.data6`]="{ item }">
            <div :class="`text-color-${item.data6Color}`" class="data-text">
              {{ item.data6 }}
            </div>
          </template>
          <template v-slot:[`item.data7`]="{ item }">
            <div :class="`text-color-${item.data7Color}`" class="data-text">
              {{ item.data7 }}
            </div>
          </template>
          <template v-slot:[`item.data8`]="{ item }">
            <div :class="`text-color-${item.data8Color}`" class="data-text">
              {{ item.data9 }}
            </div>
          </template>
          <template v-slot:[`item.data9`]="{ item }">
            <div :class="`text-color-${item.data9Color}`" class="data-text">
              {{ item.data9 }}
            </div>
          </template>
          <template v-slot:[`item.data10`]="{ item }">
            <div :class="`text-color-${item.data10Color}`" class="data-text">
              {{ item.data10 }}
            </div>
          </template>
          <!-- TS -->
          <template v-slot:[`item.d1`]="{ item }">
            <div :class="`text-color-${item.d1Color}`" class="data-text">
              {{ item.d1 !== null ? item.d1 : 'NG' }}
            </div>
          </template>
          <template v-slot:[`item.d2`]="{ item }">
            <div :class="`text-color-${item.d2Color}`" class="data-text">
              {{ item.d2 !== null ? item.d2 : 'NG' }}
            </div>
          </template>
          <template v-slot:[`item.d3`]="{ item }">
            <div :class="`text-color-${item.d3Color}`" class="data-text">
              {{ item.d3 !== null ? item.d3 : 'NG' }}
            </div>
          </template>
          <template v-slot:[`item.d4`]="{ item }">
            <div :class="`text-color-${item.d4Color}`" class="data-text">
              {{ item.d4 !== null ? item.d4 : 'NG' }}
            </div>
          </template>
          <template v-slot:[`item.d5`]="{ item }">
            <div :class="`text-color-${item.d5Color}`" class="data-text">
              {{ item.d5 !== null ? item.d5 : 'NG' }}
            </div>
          </template>
          <template v-slot:[`item.d6`]="{ item }">
            <div :class="`text-color-${item.d6Color}`" class="data-text">
              {{ item.d6 !== null ? item.d6 : 'NG' }}
            </div>
          </template>
          <template v-slot:[`item.d7`]="{ item }">
            <div :class="`text-color-${item.d7Color}`" class="data-text">
              {{ item.d7 !== null ? item.d7 : 'NG' }}
            </div>
          </template>
          <template v-slot:[`item.d8`]="{ item }">
            <div :class="`text-color-${item.d8Color}`" class="data-text">
              {{ item.d8 !== null ? item.d8 : 'NG' }}
            </div>
          </template>
          <!-- TS -->
          <div class="no-data-table">
            <template slot="no-data">
            {{ $t("notification.noData") }}
          </template>
          </div>
        </v-data-table>

        <!-- Vertical Table -->
        <v-data-table
          v-else
          class="tbl-Vertical"
          hide-default-header
          :items="transformedData"
          :headers="headerComputed"
          ref="dataTable"
          :class="classStickyVertical"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:body="{ items }">
            <tr v-for="(row, rowIndex) in items" :key="rowIndex">
              <td class="font-weight-bold header-text">
                <div style="text-align: center;" class="data-text">{{ row.header.text }}</div>
              </td>
              <td v-for="(value, colIndex) in row.values" :key="colIndex" class="data-cell">
                <div class="data-text" v-if="row.header.value == 'index'" style="
                  text-align: center !important;    
                  font-size: 16px !important;
                  background-color: #DDDFEB !important;
                  color: #000 !important;">
                  {{ value[index] }}
                </div>
                <div v-else-if="row.header.value == 'measurementTime'" class="data-text">
                  {{ commonFormatStrToDate(value[row.header.value], 7) }}
                </div>
                <div v-else-if="row.header.value == 'displayDataStation'">
                  <div class="d-flex justify-center">
                    <v-checkbox :disabled="isDetailComputed" v-model="value.displayDataStation" @change="onCheckboxChange($event, colIndex)" color="primary"
                      :value="value.displayDataStation"></v-checkbox>
                  </div>
                </div>
                <div v-else-if="row.header.value == 'data1'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] }}</div>
                </div>
                <div v-else-if="row.header.value == 'data2'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] }}</div>
                </div>
                <div v-else-if="row.header.value == 'data3'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] }}</div>
                </div>
                <div v-else-if="row.header.value == 'data4'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] }}</div>
                </div>
                <div v-else-if="row.header.value == 'data5'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] }}</div>
                </div>
                <div v-else-if="row.header.value == 'data6'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] }}</div>
                </div>
                <div v-else-if="row.header.value == 'data7'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] }}</div>
                </div>
                <div v-else-if="row.header.value == 'data8'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] }}</div>
                </div>
                <div v-else-if="row.header.value == 'data9'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] }}</div>
                </div>
                <div v-else-if="row.header.value == 'data10'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] }}</div>
                </div>
                <!-- TS -->
                <div v-else-if="row.header.value == 'd1'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] !== null ? value[row.header.value] : 'NG' }}</div>
                </div>
                <div v-else-if="row.header.value == 'd2'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] !== null ? value[row.header.value] : 'NG' }}</div>
                </div>
                <div v-else-if="row.header.value == 'd3'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] !== null ? value[row.header.value] : 'NG' }}</div>
                </div>
                <div v-else-if="row.header.value == 'd4'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] !== null ? value[row.header.value] : 'NG' }}</div>
                </div>
                <div v-else-if="row.header.value == 'd5'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] !== null ? value[row.header.value] : 'NG' }}</div>
                </div>
                <div v-else-if="row.header.value == 'd6'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] !== null ? value[row.header.value] : 'NG' }}</div>
                </div>
                <div v-else-if="row.header.value == 'd7'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] !== null ? value[row.header.value] : 'NG' }}</div>
                </div>
                <div v-else-if="row.header.value == 'd8'" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}Color`]}`">{{ value[row.header.value] !== null ? value[row.header.value] : 'NG' }}</div>
                </div>
                <div v-else-if="value[`${row.header.value}_COLOR`]" class="data-text">
                  <div :class="`text-color-${value[`${row.header.value}_COLOR`]}`">{{ value[row.header.value] }}</div>
                </div>
                <div v-else class="data-text">{{ value[row.header.value] }}</div>
              </td>
            </tr>
          </template>
          <div class="no-data-table">
            <template slot="no-data">
              {{ $t("notification.noData") }}
            </template>
          </div>
        </v-data-table>
      </div>
      </v-flex>
    </v-layout>
    <!-- </div> -->
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64" style="color: #3d76ad !important;"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { getCookieSiteUser } from "@/utils/auth";
import { initTableChart } from "@/api/frame";
import { ResponseCode } from "@/constants/constants";
import ButtonView from "@/components/ButtonView/ButtonView";
import ButtonViewSensor from "@/components/ButtonView/ButtonViewSensor";
import ButtonExportCsv from "@/components/ButtonView/ButtonExportCsv";
import ButtonExportExcel from "@/components/ButtonView/ButtonExportExcel";
import ButtonExportPdf from "@/components/ButtonView/ButtonExportPdf";
import {mapActions} from "vuex";

export default {
  name: "TC",
  components: { ButtonView, ButtonViewSensor, ButtonExportCsv, ButtonExportExcel, ButtonExportPdf },
  props: {
    width: Number,
    height: Number,
    deviceCodeProp: String,
    title: String,
    isDashboard: Boolean,
    isShowEdit: Boolean,
    isFrameSetting: Boolean,
    frameId: Number,
    useCsv: Number,
    useExcel: Number,
    usePdf: Number,
    selectedStationsProp: Array,
    limitTimeProp: Number,
    exportTypeProp: Number,
    channelNoProp: Number,
    isDetailProp: Boolean,
    rotateVertically: Boolean,
    cardTc: String
  },
  computed: {
    dynamicTop() {
      return this.firstColumnHeight - 5 + "px";
    },
    dynamic2Top() {
      return this.firstColumnHeight + this.seconColumnHeight - 10 + "px";
    },
    style() {
      // eslint-disable-next-line
      this.heightReal = this.height;
      return "height: " + this.heightReal + "px";
    },
    headerComputed() {
      if (this.isFrameSetting) {
        return this.headers.filter(x => x.isDisplay === true);
      } else {
        return this.headers.filter(x => x.isDisplay === true && x.value != "displayDataStation");
      }
      
    },
    requiredValuesComputed() {
      return this.isFrameSetting
        ? ["displayDataStation", "measurementTime", "stationName"]
        : ["measurementTime", "stationName"];
    },
    listTableComputed() {
      if (this.isFrameSetting) {     
        return this.listTable
      } else {
        return this.listTable.filter(x => x.displayDataStation === true || x.displayDataStation === "true");
      }
    },
    isDetailComputed() {
      return this.isDetailProp;
    },
    transformedData() {
      return this.headerComputed.map(header => ({
        header: {value: header.value, text: header.text},
        values: this.listTableComputed.map(row => {
          var matchingFields = Object.keys(row)
          .filter(key => key.includes(header.value))
          .reduce((acc, key) => ({ ...acc, [key]: row[key] }), {});
          return matchingFields;
        }),
      }));
    },
  },
  data() {
    return {
      signalRConnection: undefined,
      deviceCode: this.deviceCodeProp,
      heightReal: 0,
      headers: [
          {
            index: 1,
            text: this.$t('labels.framesetting.time'),
            align: "center",
            sortable: false,
            dataName: this.$t('labels.framesetting.time'),
            value: "measurementTime",
            isDisplay: true
          }
        ],
      defaultHeaders: [],
      listTable: [],
      loading: false,
      stations: [],
      limitTime: undefined,
      exportType: undefined,
      channelNo: -1,
      deviceTSList: [],
      deviceVPSList: [],
      isVertical: false,
      classSticky: null, 
      classStickyVertical: null, 
      firstColumnHeight: 0,
      seconColumnHeight: 0,
    };
  },
  created() {
    this.isVertical = this.rotateVertically;
    this.classSticky = null;
    this.classStickyVertical = null;
    if (!this.isFrameSetting) {
      this.deviceCode = this.deviceCodeProp;
      this.stations = this.selectedStationsProp;
      this.limitTime = this.limitTimeProp;
      this.exportType = this.exportTypeProp;
      this.channelNo = this.channelNoProp;
      this.getTableChartData();
    }
    this.getListDeviceMaster();
    this.getListDeviceVPS();
  },
  watch: {
    deviceCodeProp: function () {
      this.deviceCode = this.deviceCodeProp;
      this.getTableChartData();
    },
    rotateVertically(newValue) {
      this.isVertical = newValue;
    },
    transformedData: {
      handler() {
        this.$nextTick(() => {
          this.updateStickyHeader();
        });
      },
      deep: true
    },
    isVertical: {
      handler() {
        this.$nextTick(() => {
          this.updateStickyHeader();
        });
      },
      deep: true
    }
  },
  mounted() {
    if (this.isDashboard) {
      this.getTableChartData();
      this.signalRConnection = this.$dashboardHub.init();
      this.$dashboardHub.MonitorTempRealtimeTable(this.signalRConnection, [this.frameId], this.handleMonitorTableData);
    }
    this.$emit(`ChartReady`, this.frameId);
    this.$emit(`RotateVertically`);
    this.setOverflowY();
    this.updateStickyHeader();
    window.addEventListener("resize", this.updateStickyHeader);
  },
  beforeDestroy() {
    this.$dashboardHub.stop(this.signalRConnection);
    window.removeEventListener("resize", this.updateStickyHeader);
  },
  methods: {
    getTableName(){
      return{
        'table-ts col-xl-12 col-lg-12 col-12': this.isDeviceTsOrSimilarTs(Number(this.deviceCode)) || this.isDeviceVPS(Number(this.deviceCode)),
        'table-other col-xl-12 col-lg-12 col-12': !this.isDeviceTsOrSimilarTs(Number(this.deviceCode)) && !this.isDeviceVPS(Number(this.deviceCode))
      }
    },
    ...mapActions("deviceMaster", {
      getDeviceList: "getDeviceList"
    }),
    humanReadableDirection(windDirection) {
      // console.log("this.indexW>>>>", this.indexW);
      // return this.dispHoui16[this.indexW];
      if (windDirection < 11.25) {
        return this.$t("compass.N");
      }
      if (windDirection >= 11.25 && windDirection <= 33.75) {
        return this.$t("compass.NNE");
      }
      if (windDirection > 33.75 && windDirection <= 56.25) {
        return this.$t("compass.NE");
      }
      if (windDirection > 56.25 && windDirection <= 78.75) {
        return this.$t("compass.ENE");
      }
      if (windDirection > 78.75 && windDirection <= 101.25) {
        return this.$t("compass.E");
      }
      if (windDirection > 101.25 && windDirection <= 123.75) {
        return this.$t("compass.ESE");
      }
      if (windDirection > 123.75 && windDirection <= 146.25) {
        return this.$t("compass.SE");
      }
      if (windDirection > 146.25 && windDirection <= 168.75) {
        return this.$t("compass.SSE");
      }
      if (windDirection > 168.75 && windDirection <= 191.25) {
        return this.$t("compass.S");
      }
      if (windDirection > 191.25 && windDirection <= 213.75) {
        return this.$t("compass.SSW");
      }
      if (windDirection > 213.75 && windDirection <= 236.25) {
        return this.$t("compass.SW");
      }
      if (windDirection > 236.25 && windDirection <= 258.75) {
        return this.$t("compass.WSW");
      }
      if (windDirection > 258.75 && windDirection <= 281.25) {
        return this.$t("compass.W");
      }
      if (windDirection > 281.25 && windDirection <= 303.75) {
        return this.$t("compass.WNW");
      }
      if (windDirection > 303.75 && windDirection <= 326.25) {
        return this.$t("compass.NW");
      }
      if (windDirection > 326.25 && windDirection <= 348.75) {
        return this.$t("compass.NNW");
      }
      if (windDirection > 348.75) {
        return this.$t("compass.N");
      }
      return windDirection;
    },
    getTableChartData() {
      if (this.deviceCode) {
        if (!this.isDeviceTsOrSimilarTs(Number(this.deviceCode)) && !this.stations.length > 0) {
          return;
        } else if (this.isDeviceTsOrSimilarTs(Number(this.deviceCode)) && this.channelNo === -1) {
          return;
        }
        //  else if (this.isDeviceVPS(Number(this.deviceCode)) && (this.channelNo == 0 || this.channelNo)) {
        //   return;
        // } else if (this.isDeviceTsOrSimilarTs(Number(this.deviceCode)) && (this.channelNo !== 0 || this.channelNo == null || this.channelNo == undefined )){
        //   return;
        // }
      }
      this.loading = true;
      const request = {
        stations: this.stations,
        // day: this.limitTime,
        deviceCode: this.deviceCode,
        siteId: getCookieSiteUser(),
        PAGE_CODE: (this.isDashboard) ? "CS_DA" : "CS_GM",
        frameId: this.frameId,
        channelNo: this.channelNo,
        exportType: this.exportType
      };
      initTableChart(request)
        .then((response) => {
          if (response?.data?.code === ResponseCode.SUCCESS) {
            this.generateHeader(response.data.data);
          } else {
            this.commonNotifyVue(
              this.ERROR_CODE[response.data.code],
              "warning"
            );
          }
        })
        .catch((err) => {
          if (err.code != undefined)
            this.commonNotifyVue(this.ERROR_CODE[err.code], "warning");
        })
        .finally((final) => {
          this.loading = false;
        });
    },
    handleMonitorTableData(response) {
      try {
        var keysDataTable = this.listTable.map(i => i.measurementTime);
        if (response !== undefined) {
          if (response.code === 0) {
            if (response.data[this.frameId] != undefined) {
              if (!this.isDeviceTsOrSimilarTs(Number(this.deviceCode)) && !this.isDeviceVPS(Number(this.deviceCode))) {
                if (response.data[this.frameId] != null && response.data[this.frameId] != undefined && response.data[this.frameId].length > 0) {
                  response.data[this.frameId].forEach(value => {
                    var indexDataCheck = keysDataTable.indexOf(value.measurementTime);
                    if (this.listTable.length == 0 && indexDataCheck > -1) {
                      this.listTable.push(value);
                    }
                    if (indexDataCheck == -1) {
                      this.listTable.unshift(value);
                    }
                    if (this.listTable.length > 3600) {
                      this.listTable.splice(-1);
                    }
                  });
                }
              } else {
                if (response.data[this.frameId] != null && response.data[this.frameId] != undefined && response.data[this.frameId].length > 0) {
                  this.listTable = response.data[this.frameId];
                }
              }
            }
          }
        }
      } catch (error) {
        console.log('[handleMonitorTableData][ERROR]', error);
      }
    },
    clickClose() {
      this.$emit(`closeFrame`, this.frameId);
    },
    generateHeader(response) {
      const timeHeader = {
        index: 1,
        text: this.$t('labels.framesetting.time'),
        align: "center",
        sortable: false,
        dataName: this.$t('labels.framesetting.time'),
        value: "measurementTime",
        isDisplay: true,
      };
      if (response.headers && response.deviceCode === this.deviceCodeProp) {
        this.headers = JSON.parse(response.headers);
        const timeIndex = this.headers.findIndex(header => header.value == "measurementTime");
        if (timeIndex === -1) {
          this.headers.unshift(timeHeader);
        } else {
          if (!this.headers[timeIndex].index) {
            this.headers.splice(timeIndex, 1);
            // this.headers.unshift(timeHeader);
            if (this.isDeviceTsOrSimilarTs(Number(this.deviceCode)) || this.isDeviceVPS(Number(this.deviceCode))) {
              this.headers.splice(1, 0, timeHeader);
            } else {
              this.headers.unshift(timeHeader);
            }
          }
        }
        
        let index = 1;
        this.headers.forEach(element => {
          if(element.index) {
            element.index = index++
          }
        });
        this.$emit("change-header", this.headers);
      } else {
        this.headers = [];
        if (this.isDeviceTsOrSimilarTs(Number(this.deviceCode)) || this.isDeviceVPS(Number(this.deviceCode))) {
          this.headers.push({
            text: this.$t('labels.framesetting.display'),
            align: "center",
            sortable: false,
            dataName: this.$t('labels.framesetting.display'),
            value: "displayDataStation",
            isDisplay: true
          });
          this.headers.push({
            index: 1,
            text: this.$t('labels.framesetting.time'),
            align: "center",
            sortable: false,
            dataName: this.$t('labels.framesetting.time'),
            value: "measurementTime",
            isDisplay: true
          });
          this.headers.push({
            text: this.$t('labels.framesetting.station'),
            align: "center",
            sortable: false,
            dataName: this.$t('labels.framesetting.station'),
            value: "stationName",
            isDisplay: true
          });
        } else {
          this.headers.push({
            index: 1,
            text: this.$t('labels.framesetting.time'),
            align: "center",
            sortable: false,
            dataName: this.$t('labels.framesetting.time'),
            value: "measurementTime",
            isDisplay: true
          });
        }

        response.defaultHeader.forEach((element, index) => {
          const unit = element?.unit != undefined && element?.unit != null && element?.unit != "" ? " (" + element?.unit + ")" : "";
          const item = {
            index: ++index + 1,
            data: element.dataMapping,
            dataCode: element.dataCode,
            measurementTime: element.measurementTime,
            dataName:
              this.$i18n.locale === "en"
                ? element?.nameEn + unit
                : element?.nameJp + unit,
            text: this.$i18n.locale === "en"
              ? element?.nameEn + unit
              : element?.nameJp + unit,
            value: element?.dataMapping,
            align: "center",
            sortable: false,
            isDisplay: true,
          };
          this.headers.push(item);
        });
        
        this.$emit("change-header", this.headers);
      }
      
      const matchedHeaders = this.headers.filter(x => this.requiredValuesComputed.includes(x.value) && x.isDisplay == true);
      if (matchedHeaders.length === 3) {
        this.classSticky = "tableSticky3";
        this.classStickyVertical = "tableStickyVertical3";
      } else if (matchedHeaders.length === 2) {
        this.classSticky = "tableSticky2"; 
        this.classStickyVertical = "tableStickyVertical2";
      } else if (matchedHeaders.length === 1){
        this.classSticky = "tableSticky1";
        this.classStickyVertical = "tableStickyVertical1";
      } else {
        this.classSticky = null;
        this.classStickyVertical = null;
      }

      if (!this.isDeviceTsOrSimilarTs(Number(response.deviceCode)) && !this.isDeviceVPS(Number(response.deviceCode))) {
        if(response?.rows == null){
          this.classSticky = null;
          this.classStickyVertical = null;
        }
        this.listTable = response?.rows != null ? response?.rows : [];
      }
      else {
        if (this.isDeviceVPS(Number(response.deviceCode))) {
          this.headers[0].isDisplay = this.isFrameSetting;
          if(response?.rowsVps == null){
            this.classSticky = null;
            this.classStickyVertical = null;
          }
          this.listTable = response?.rowsVps != null ? response?.rowsVps : [];
          if (!this.isFrameSetting) {
            this.listTable = response.rowsVps.filter(item => item.displayDataStation);
          }
          for (let index = 0; index < this.listTable.length; index++) {
            this.listTable[index].displayDataStation = this.listTable[index].displayDataStation == true || this.listTable[index].displayDataStation == "true";
          }
        } else {
          this.headers[0].isDisplay = this.isFrameSetting;
          if(response?.rowsTs == null){
            this.classSticky = null;
            this.classStickyVertical = null;
          }
          this.listTable = response?.rowsTs != null ? response?.rowsTs : [];
          // var stationListTs = this.listTable.filter(x => x.displayDataStation === true || x.displayDataStation === "true").map(x => x.stationName).join("/");
          // stationListTs = stationListTs.length > 0 ? stationListTs : "''";
          // var updateQuery = `UPDATE kcloud.frame SET list_station_ts = '${stationListTs}' WHERE frame.id = ${this.frameId}`
          // console.log("updateQuery", updateQuery);
          if (!this.isFrameSetting) {
            this.listTable = response.rowsTs.filter(item => item.displayDataStation);
          }
        }
      }
    },
    getDisplayStationTsList() {
      let displayStationTsList = [];
      if (this.listTable && this.listTable?.length > 0) {
        this.listTable.forEach(item => {
          if (!item.displayDataStation) {
            displayStationTsList.push(item.stationName);
          }
        })
      }
      return displayStationTsList;
    },
    onChangeHeader(listHeader) {
      this.headers = listHeader;
      const matchedHeaders = this.headers.filter(x => this.requiredValuesComputed.includes(x.value) && x.isDisplay == true);
      if (matchedHeaders.length === 3) {
        this.classSticky = "tableSticky3";
        this.classStickyVertical = "tableStickyVertical3";
      } else if (matchedHeaders.length === 2) {
        this.classSticky = "tableSticky2"; 
        this.classStickyVertical = "tableStickyVertical2";
      } else if (matchedHeaders.length === 1){
        this.classSticky = "tableSticky1";
        this.classStickyVertical = "tableStickyVertical1";
      } else {
        this.classSticky = null;
        this.classStickyVertical = null;
      }
    },
    onChangeVertically(value) {
      this.isVertical = value;
    },
    getListDeviceMaster() {
      this.getDeviceList({ deviceType: 1 })
        .then(response => {
          if (response.code === 0) {
            this.deviceTSList = response.data.deviceList.map(x => x.code);
          } else {
            this.commonNotifyVue(this.ERROR_CODE[response.code], 'warning');
          }
        })
        .catch(err => {
          console.log(err);
          if(err.code != undefined)
            this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
        })
        .finally(final => {
          this.isSubmitAction = false;
        });
    },
    isDeviceTsOrSimilarTs(deviceCode){
      return this.deviceTSList !== null && this.deviceTSList.length > 0 && this.deviceTSList.includes(deviceCode);
    },
    getListDeviceVPS() {
      this.getDeviceList({ deviceType: 3 })
        .then(response => {
          if (response.code === 0) {
            this.deviceVPSList = response.data.deviceList.map(x => x.code);
          } else {
            this.commonNotifyVue(this.ERROR_CODE[response.code], 'warning');
          }
        })
        .catch(err => {
          console.log(err);
          if(err.code != undefined)
            this.commonNotifyVue(this.ERROR_CODE[err.code], 'warning');
        })
        .finally(final => {
          this.isSubmitAction = false;
        });
    },
    isDeviceVPS(deviceCode) {
      return this.deviceVPSList !== null && this.deviceVPSList.length > 0 && this.deviceVPSList.includes(deviceCode);
    },
    setOverflowY() { 
      var dataTableWrapper = this.$refs.dataTable.$el.querySelector('.v-data-table__wrapper'); 
      if (dataTableWrapper) { dataTableWrapper.style.overflowY = 'auto'; dataTableWrapper.style.important = 'true'; } 
      this.$nextTick(() => {
        this.updateStickyHeader(); // Cập nhật lại chiều cao header khi có dữ liệu mới
      });
    },
    onCheckboxChange(event, index) {
      var itemInListTableComputed = this.listTableComputed[index]
      if(itemInListTableComputed){
        itemInListTableComputed.displayDataStation = event
      }
    },
    updateStickyHeader() {
      this.$nextTick(() => {
        const tableEl = this.$refs.dataTable?.$el;
        if (tableEl) {
          const rows = tableEl.querySelectorAll("tr");
          this.firstColumnHeight = rows[0].getBoundingClientRect().height;
          this.seconColumnHeight = rows[1].getBoundingClientRect().height;
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
.data-cell { 
  text-align: center; 
  padding: 5px 16px; 
  border-bottom: 1px solid #e0e0e0;
}
.header-text{
  background-color: #DDDFEB !important;
  padding: 5px;
  border-top: 1px solid #ebebeb !important;
  border-bottom: 1px solid #ebebeb !important;
}

.data-text{
  text-align: center;
}

.text-center {
  text-align: center;
}

.table-container {
  display: flex;
  margin-top: 20px;
  flex-grow: 1;
  overflow: hidden;
}

.flex-table {
  display: flex;
  flex-grow: 1;
  width: 100%;
}

.flex-table>div {
  width: 100%;
}

.text-color-green {
  font-weight: bold;
  background-color: #3BA272;
}
.text-color-yellow {
  font-weight: bold;
  background-color: #FAC858;
}
.text-color-red {
  font-weight: bold;
  background-color: #EE6666;
}
.text-color-376CA5 {
  background-color: #376CA5;
}
.tbl-Vertical{
  table-layout: fixed !important;
  table > tr > td:nth-child(1) {
    position: sticky !important; 
    left: -2px;
    z-index: 4;
  }
}

::v-deep{
  .v-data-table {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .v-data-table--fixed-header > .v-data-table__wrapper {
    height: 100% !important;
  } 
  .v-data-table--fixed-header > .v-data-table__wrapper {
    .v-data-table-header{
      tr{
        th{
          border-top: 0 !important;
          top: -2px !important;
          border-left: 0 !important;
          padding: 5px;
        }
      }
    }
    .v-data-table-header{
      tr{
        td{
          border-left: 0 !important;
          top: -2px !important;
          left: -2px !important;
        }
      }
    }
  }
  .tableSticky1, .tableSticky2, .tableSticky3 {
    height: 100%;
  }

  .tableStickyVertical1, .tableStickyVertical2, .tableStickyVertical3 {
    height: 100%;
  }

  @media only screen and (min-width: 501px){
    .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
      width: 150px;
      font-size: 16px !important;
    }
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
      font-size: 16px !important;
    }
    .v-data-table-header th {
      width: 135px !important;
      min-width: 135px !important;
      max-width: 135px !important;
      text-align: center;
    }
    .data-text{
      font-size: 16px !important;
    }
    .tableSticky1 {
        table > tbody > tr > td:nth-child(1) {
        position: sticky !important; 
        left: -2px; 
        z-index: 4;
        background-color: white;
      }
        table > thead > tr > th:nth-child(1){
        position: sticky !important; 
        left: -2px; 
        top: -2px;
        z-index: 5;
        background-color: white;
      }
    }
    .tableSticky2{
      table > tbody > tr > td:nth-child(1) {
        position: sticky !important; 
        left: -2px; 
        z-index: 4;
        background-color: white;
      }
      table > tbody > tr > td:nth-child(2) {
        position: sticky !important; 
        left: calc(1 * 130px); 
        z-index: 4;
        background-color: white;
      }
      table > thead > tr > th:nth-child(1) {
        position: sticky !important; 
        top: -2px;
        left: -2px; 
        z-index: 5;
        background-color: white;
      }
      table > thead > tr > th:nth-child(2) {
        position: sticky !important; 
        top: -2px;
        left: calc(1 * 130px); 
        z-index: 5;
        background-color: white;
      }
    }
    .tableSticky3{
      table > tbody > tr > td:nth-child(1) {
        position: sticky !important; 
        left: -2px; 
        z-index: 4;
        background-color: white;
      }
      table > tbody > tr > td:nth-child(2) {
        position: sticky !important; 
        left: calc(1 * 130px); 
        z-index: 4;
        background-color: white;
      }
      table > tbody > tr > td:nth-child(3) {
        position: sticky !important; 
        left: calc(2 * 130px); 
        z-index: 4;
        background-color: white;
      }
      table > thead > tr > th:nth-child(1) {
        position: sticky !important; 
        top: -2px;
        left: -2px; 
        z-index: 5;
        background-color: white;
      }
      table > thead > tr > th:nth-child(2) {
        position: sticky !important; 
        top: -2px;
        left: calc(1 * 130px); 
        z-index: 5;
        background-color: white;
      }
      table > thead > tr > th:nth-child(3) {
        position: sticky !important; 
        top: -2px;
        left: calc(2 * 130px); 
        z-index: 5;
        background-color: white;
      }
    }

    //Use with table Vertical
    .tableStickyVertical1{
      table > tr:nth-child(2){
        position: sticky !important; 
        top: -2px;
        z-index: 5;
        background: white;
      }
    }
    .tableStickyVertical2{
      table > tr:nth-child(2){
        position: sticky !important; 
        top: -2px;
        z-index: 5;
        background: white;
      }
      table > tr:nth-child(3){
        position: sticky !important; 
        top: v-bind(dynamicTop); 
        z-index: 5;
        background: white;
      }
    }
    .tableStickyVertical3{
      table > tr:nth-child(2){
        position: sticky !important; 
        top: -2px;
        z-index: 5;
        background: white;
      }
      table > tr:nth-child(3){
        position: sticky !important; 
        top: v-bind(dynamicTop); 
        z-index: 5;
        background: white;
      }
      table > tr:nth-child(4){
        position: sticky !important; 
        top: v-bind(dynamic2Top); 
        z-index: 5;
        background: white;
      }
    }
  }
  @media only screen and (max-width: 500px) {
    .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
      font-size: 14px !important;
    }
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
      font-size: 14px !important;
    }
    .v-data-footer__pagination {
      margin-left: 3.55rem !important;
    }
    .v-card__text {
      margin-left: -1rem !important;
      width: 115% !important;
    }

    .v-data-table-header th {
      width: 110px !important;
      min-width: 110px !important;
      max-width: 110px !important;
      text-align: center;
    }
   
    .tbl-Vertical .v-data-table__wrapper tr td{
      min-width: 110px !important;
      max-width: 110px !important;
      width: 110px !important;
      font-size: 14px;
    }

    .data-text{
      font-size: 14px !important;
    }
    
    .tableSticky1 {
        table > tbody > tr > td:nth-child(1) {
        position: sticky !important; 
        left: -2px; 
        z-index: 4;
        background-color: white;
      }
        table > thead > tr > th:nth-child(1){
        position: sticky !important; 
        left: -2px; 
        top: -2px;
        z-index: 5;
        background-color: white;
      }
    }
    .tableSticky2{
      table > tbody > tr > td:nth-child(1) {
        position: sticky !important; 
        left: -2px; 
        z-index: 4;
        background-color: white;
      }
      table > tbody > tr > td:nth-child(2) {
        position: sticky !important; 
        left: calc(1 * 105px); 
        z-index: 4;
        background-color: white;
      }
      table > thead > tr > th:nth-child(1) {
        position: sticky !important; 
        top: -2px;
        left: -2px; 
        z-index: 5;
        background-color: white;
      }
      table > thead > tr > th:nth-child(2) {
        position: sticky !important; 
        top: -2px;
        left: calc(1 * 105px); 
        z-index: 5;
        background-color: white;
      }
    }
    .tableSticky3{
      table > tbody > tr > td:nth-child(1) {
        position: sticky !important; 
        left: -2px; 
        z-index: 4;
        background-color: white;
      }
      table > tbody > tr > td:nth-child(2) {
        position: sticky !important; 
        left: calc(1 * 105px); 
        z-index: 4;
        background-color: white;
      }
      table > tbody > tr > td:nth-child(3) {
        position: sticky !important; 
        left: calc(2 * 105px); 
        z-index: 4;
        background-color: white;
      }
      table > thead > tr > th:nth-child(1) {
        position: sticky !important; 
        top: -2px;
        left: -2px; 
        z-index: 5;
        background-color: white;
      }
      table > thead > tr > th:nth-child(2) {
        position: sticky !important; 
        top: -2px;
        left: calc(1 * 105px); 
        z-index: 5;
        background-color: white;
      }
      table > thead > tr > th:nth-child(3) {
        position: sticky !important; 
        top: -2px;
        left: calc(2 * 105px); 
        z-index: 5;
        background-color: white;
      }
    }

    //Use with table Vertical
    .tableStickyVertical1{
      table > tr:nth-child(2){
        position: sticky !important; 
        top: -2px;
        z-index: 5;
        background: white;
      }
    }
    .tableStickyVertical2{
      table > tr:nth-child(2){
        position: sticky !important; 
        top: -2px;
        z-index: 5;
        background: white;
      }
      table > tr:nth-child(3){
        position: sticky !important; 
        top: v-bind(dynamicTop); 
        z-index: 5;
        background: white;
      }
    }
    .tableStickyVertical3{
      table > tr:nth-child(2){
        position: sticky !important; 
        top: -2px;
        z-index: 5;
        background: white;
      }
      table > tr:nth-child(3){
        position: sticky !important; 
        top: v-bind(dynamicTop); 
        z-index: 5;
        background: white;
      }
      table > tr:nth-child(4){
        position: sticky !important; 
        top: v-bind(dynamic2Top); 
        z-index: 5;
        background: white;
      }
    }
  }
}
@media (min-width: 1286px) {
  [data-v-c0f4d8c8][data-v-c0f4d8c8] .card[data-v-c0f4d8c8] {
    margin-top: 0rem !important;
  }
}
@media (max-width: 1285px) {
  [data-v-c0f4d8c8][data-v-c0f4d8c8] .card[data-v-c0f4d8c8] {
    margin-top: 35rem !important;
  }
}

@media (max-width: 1285px) {
  [data-v-c0f4d8c8][data-v-c0f4d8c8] .cardVPS[data-v-c0f4d8c8] {
    margin-top: 32rem !important;
  }
}

@media (max-width: 1285px) {
  [data-v-c0f4d8c8][data-v-c0f4d8c8] .cardTS[data-v-c0f4d8c8] {
    margin-top: 38rem !important;
  }
}
</style>


